import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface InscriptionOption {
  id: string;
  label: string;
  active: boolean;
  sortOrder: number;
  createdAt: string;
}

interface UseInscriptionOptionsResult {
  options: InscriptionOption[];
  loading: boolean;
}

export function useInscriptionOptions(): UseInscriptionOptionsResult {
  const [options, setOptions] = useState<InscriptionOption[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchOptions = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiClient<InscriptionOption[]>(
        '/weekend-booklet/inscription-options',
      );
      setOptions(data);
    } catch {
      setOptions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return { options: options.filter((o) => o.active), loading };
}
